import type { Permission } from '@nexops/shared';

/**
 * Who can open "Zapytaj NEXOPS": sales AI (`ai.insights`) or logistics AI (`logistics.insights` — logistics, order desk,
 * sales manager, board, admin). Any of them. The backend decides which tools / data each user gets.
 */
export const AI_ASSISTANT_PERMISSIONS: readonly Permission[] = ['ai.insights', 'logistics.insights'];
